<template>
  <page-table title="Address Book" subtitle=" ">
    <template v-slot:button>
      <router-link :to="{name: 'new-address-book-entry'}" class="btn waves-effect waves-light btn-success">
        New Address Book Entry
      </router-link>
    </template>
    <template v-slot:filter>
      <div class="row m-b-10">
        <label for="status" class="col-form-label p-l-10">Address Type:</label>
        <div class="col-auto p-t-5">
          <select id="status" v-model="filter" aria-controls="lang_opt" class="col-auto form-control form-control-sm rounded" name="lang_opt_length">
            <option value="Group">
              Group
            </option>
            <option value="Account">
              Account
            </option>
            <option value="Did">
              Did
            </option>
            <option value="">
              All
            </option>
          </select>
        </div>
      </div>
    </template>
    <template v-slot:table>
      <b-table tbody-tr-class="rowClass" striped :items="address_book_entries" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filter-included-fields="filterOn" :sort-by="sortBy" :sort-desc="sortDesc" :sort-direction="sortDirection">
        <template #cell(public_key)="data">
          {{ data.value | hex_format(10, '....') }}
        </template>
        <template #cell(created_at)="data">
          {{ data.value | date }}
        </template>
        <template #cell(actions)="data">
          <router-link v-if="data.item.address_book_entry" :to="{name: 'address-book-edit', params: {addressbookid: data.item.address_book_entry}}" class="text-indigo font-18 fa fa-border fa-pencil-alt" style="cursor: pointer" title="Edit Address Book Entry" />
          <i class="text-danger m-l-5 font-18 fa fa-border fa-trash-alt" data-target="#deleteModal" data-toggle="modal" style="cursor: pointer" title="Delete Address Book Entry" @click="delete_entry(data.item.address_book_entry)" />
        </template>
      </b-table>
    </template>
    <template v-slot:pagenator>
      <div v-if="address_book_entries.length>5" class="card-footer">
        <div class="row">
          <div class="col">
            <per-page v-model="perPage" />
          </div>
          <div v-if="address_book_entries.length>perPage" class="col-auto">
            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" />
          </div>
        </div>
      </div>
    </template>

    <template v-slot:modals>
      <div id="deleteModal" aria-hidden="true" aria-labelledby="myModalLabel" class="modal fade" role="dialog" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body card-blue">
              <div class="text-center m-t-20 m-b-10">
                <i class="fa fa-exclamation-triangle text-warning" style="font-size:50px" />
                <br><br>
                <h4>Are you sure you want to remove this entry?</h4>
                <button :disabled="isDeleted" class="btn waves-effect waves-light btn-success m-r-15" type="button" @click="deleteAddrBook()">
                  <span v-if="!isDeleted">Yes</span>
                  <span v-if="isDeleted"><i class="fa fa-spinner fa-spin" /> &nbsp;Loading</span>
                </button>
                <button class="btn waves-effect waves-light btn-danger" data-dismiss="modal" type="button">
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </page-table>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTable from '../../PageTable.vue'
import PerPage from '@/components/protected/common/PerPage.vue'

export default {
  name: 'AddressBookEntries',
  components: { PageTable, PerPage },
  data () {
    return {
      fields: [
        {
          key: 'address_type',
          label: 'Address Type',
          sortable: true
        },
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'description'
        },
        {
          key: 'group_id',
          label: 'Group ID'
        },
        {
          key: 'public_key',
          label: 'Address'
        },
        {
          key: 'created_at',
          label: 'Created'
        },
        {
          key: 'actions'
        }
      ],
      isDeleted: false,
      address_book_entry_to_delete: null,
      address_book_entries: [],
      currentPage: 1,
      filter: '',
      filterOn: ['address_type'],
      sortBy: 'address_type',
      sortDesc: false,
      sortDirection: 'asc',
      perPage: 5
    }
  },
  computed: {
    /** @returns {number} */
    totalRows () { return this.address_book_entries.length },
    ...mapGetters(['userAddressBook'])
  },
  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.address_book_entries = this.userAddressBook ? this.userAddressBook : []
    },

    delete_entry (address_book_entry) {
      this.address_book_entry_to_delete = address_book_entry
    },
    async deleteAddrBook () {
      try {
        this.isDeleted = true
        if (this.address_book_entry_to_delete) {
          await this.$accounts.delete(`/addressbook/${this.address_book_entry_to_delete}/user`)
          this.$store.commit('REMOVE_ADDRESS_BOOK_ITEM', this.address_book_entry_to_delete)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.isDeleted = false
        $('#deleteModal').modal('toggle')
      }
    }
  }
}
</script>

<style>
.rowClass td {
  vertical-align: middle;
}
</style>
